import React, { useState, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ActionIcon, Modal, Loader, NativeSelect } from '@mantine/core';
import { FilePond, registerPlugin } from 'react-filepond';
import { Trash } from 'tabler-icons-react';
import { showNotification } from '@mantine/notifications';
import { useForm as manTineForm, formList } from '@mantine/form';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { FirebaseContext } from '../Firebase';
import { navigate } from 'gatsby';

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);

const Midwifery = (props) => {
  const { register, reset, handleSubmit, errors, setError, watch } = useForm();
  const [files, setFiles] = useState([]);
  const [passport, setPassport] = useState([]);
  const [appNoSt, setAppNo] = useState('');
  const [sFiles, setSFiles] = useState({});
  const [submittedData, setSubmittedData] = useState({});
  const [local, setLocal] = useState({});
  const [opened, setOpened] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [loading, setLoading] = useState(false);
  let docURLs = [];
  let picURL = [];
  let picType = '';
  const { firebase, user } = useContext(FirebaseContext);

  useEffect(() => {
    const test = localStorage.getItem('local');
    const parsed = JSON.parse(test);
    setLocal({ ...parsed });
  }, []);

  useEffect(() => {
    // if(firebase){
    //   firebase.listall().then((data) => {
    //     console.log('sent', data);
    //   });
    //   firebase.computeSplit();
    //   firebase.juju();
    // }

  }, [firebase]);

  // useEffect(() => {
  //   console.log('sfiles', sFiles);
  // }, [sFiles]);

  const uploadDocsPromise = (docFile, userId) => {
    const path = `registrations/${userId}/docs/`;
    return new Promise((resolve, reject) => {
      if (!docFile) return reject('No document to upload');
      firebase
        .storeFiles({ path: path + docFile.file.name, docFile: docFile.file })
        .then((urls) => {
          docURLs.push({
            url: urls,
            name: docFile.file.name,
          });
          resolve(urls);
        });
    });
  };

  const uploadPicPromise = (docFile, userId) => {
    const path = `registrations/${userId}/pic/`;
    return new Promise((resolve, reject) => {
      if (!docFile) return reject('No image to upload');
      return firebase
        .storeFiles({ path: path + docFile.file.name, docFile: docFile.file })
        .then((urls) => {
          picType = docFile.file.type;
          picURL.push(urls);
          resolve(urls);
        })
        .catch(() => {
          setLoading(false);
          setErrorModal(true);
          return reject;
        });
    });
  };

  const form = manTineForm({
    initialValues: {
      professional: formList([]),
      employment: formList([]),
      education: formList([]),
      // documents: formList([]),
    },
  });

  const onSubmit = (raw) => {
    setSubmittedData(raw);
    firebase.listall().then(()=>{
      console.log('sent');
    })
    firebase.checkTransStatus({ code: '120672741587' }).then((data)=>{
      console.log('ddd', data);
    })
    setLoading(true);
    raw.DateSubmitted = Date.now();
    const authUser = localStorage.getItem('authUser');
    const localhere = localStorage.getItem('local');
    const parsedUser = JSON.parse(authUser);
    const parsedLocal = JSON.parse(localhere);
    raw.flag = 'Submitted';
    raw.course = 'Midwifery';

    if (files.length !== 0 && passport.length !== 0) {
      Promise.all(
        files.map((item) => uploadDocsPromise(item, parsedLocal.userId))
      )
        .then(() => {
          Promise.all(
            passport.map((item) => uploadPicPromise(item, parsedLocal.userId))
          )
            .then(() => {
              raw.documents = docURLs;
              raw.uid = parsedLocal.userId;
              raw.passport = picURL[0];
              raw.picType = picType;
              const data = { ...raw, ...form.values };
              firebase
                .applyCourse({ data, id: parsedLocal.userId })
                .then((data) => {
                  if (data === 'no doc') {
                    setLoading(false);
                    setErrorModal(true);
                  } else {
                    setLoading(false);
                    setOpened(true);
                    setAppNo(data);
                    reset({ ...submittedData });
                  }
                });
            })
            .catch(() => {
              setLoading(false);
              setErrorModal(true);
            });
        })
        .catch(() => {
          setLoading(false);
          setErrorModal(true);
        });
    } else {
      setLoading(false);
      showNotification({
        title: 'Error',
        color: 'red',
        message:
          'Select supporting documents to upload and passport photograph, before submitting',
      });
    }
  };

  const proFields = form.values.professional.map((_, index) => (
    <div className='row rowStyle' key={index}>
      <div className='col-lg-4'>
        <span className='form-span'>Training institution</span>
        <input
          type='text'
          name={`pro${index}`}
          {...form.getListInputProps('professional', index, 'name')}
        />
      </div>
      <div className='col-lg-2'>
        <span className='form-span'>Date Commenced</span>
        <input
          type='text'
          name={`proCommenced${index}`}
          {...form.getListInputProps('professional', index, 'commenced')}
        />
      </div>
      <div className='col-lg-2'>
        <span className='form-span'>Date Left</span>
        <input
          type='text'
          {...form.getListInputProps('professional', index, 'left')}
          name={`proLeft${index}`}
        />
      </div>
      <div className='col-lg-3'>
        <span className='form-span'>Certificate number</span>
        <input
          name={`number${index}`}
          type='text'
          {...form.getListInputProps('professional', index, 'number')}
        />
      </div>
      <div className='col-lg-1'>
        <ActionIcon
          color='red'
          variant='hover'
          onClick={() => form.removeListItem('professional', index)}
        >
          <Trash size={16} />
        </ActionIcon>
      </div>
    </div>
  ));

  const empFields = form.values.employment.map((_, index) => (
    <div className='row rowStyle' key={index}>
      <div className='col-lg-4'>
        <span className='form-span'>Employer</span>
        <input
          type='text'
          name={`employer${index}`}
          {...form.getListInputProps('employment', index, 'name')}
        />
      </div>
      <div className='col-lg-2'>
        <span className='form-span'>Date</span>
        <input
          type='text'
          name={`employDate${index}`}
          {...form.getListInputProps('employment', index, 'date')}
        />
      </div>
      <div className='col-lg-2'>
        <span className='form-span'>Post held & duties</span>
        <input
          type='text'
          {...form.getListInputProps('employment', index, 'post')}
          name={`post${index}`}
        />
      </div>
      <div className='col-lg-3'>
        <span className='form-span'>Reason for leaving</span>
        <input
          name={`reason${index}`}
          type='text'
          {...form.getListInputProps('employment', index, 'reason')}
        />
      </div>
      <div className='col-lg-1'>
        <ActionIcon
          color='red'
          variant='hover'
          onClick={() => form.removeListItem('employment', index)}
        >
          <Trash size={16} />
        </ActionIcon>
      </div>
    </div>
  ));

  const eduFields = form.values.education.map((_, index) => (
    <div className='row rowStyle' key={index}>
      <div className='col-lg-4'>
        <span className='form-span'>Secondary school attended</span>
        <input
          type='text'
          name={`school${index}`}
          {...form.getListInputProps('education', index, 'name')}
        />
      </div>
      <div className='col-lg-2'>
        <span className='form-span'>Date commenced</span>
        <input
          type='text'
          name={`eduCommenced${index}`}
          {...form.getListInputProps('education', index, 'commenced')}
        />
      </div>
      <div className='col-lg-2'>
        <span className='form-span'>Date Left</span>
        <input
          type='text'
          {...form.getListInputProps('education', index, 'left')}
          name={`eduLeft${index}`}
        />
      </div>
      <div className='col-lg-3'>
        <span className='form-span'>Subject and grades</span>
        <textarea
          {...form.getListInputProps('education', index, 'subjects')}
          name={`subject${index}`}
        />
      </div>
      <div className='col-lg-1'>
        <ActionIcon
          color='red'
          variant='hover'
          onClick={() => form.removeListItem('education', index)}
        >
          <Trash size={16} />
        </ActionIcon>
      </div>
    </div>
  ));

  // const docFields = form.values.documents.map((_, index) => (
  //   <div className='row rowStyle' key={index}>
  //     <div className='col-lg-6'>
  //       <span className='form-span'>Type of document</span>
  //       <NativeSelect
  //         name={`type${index}`}
  //         required
  //         {...form.getListInputProps('documents', index, 'type')}
  //         data={[
  //           {
  //             value: "Original O'Level Certificate",
  //             label: "Original O'Level Certificate",
  //           },
  //           {
  //             value: 'Original Practicing License',
  //             label: 'Original Practicing License',
  //           },
  //           {
  //             value: 'Original Certificate/Notification in General Nursing',
  //             label: 'Original Certificate/Notification in General Nursing'
  //           },
  //           {
  //             value: 'Birth Certificate/declaration of age',
  //             label: 'Birth Certificate/declaration of age'
  //           },
  //           {
  //             value: 'School of Nursing Testimonial/Department of Nursing reference letter',
  //             label: 'School of Nursing Testimonial/Department of Nursing reference letter'
  //           },
  //           {
  //             value: 'Marriage certificate and change of name (newspaper publication)',
  //             label: 'Marriage certificate and change of name (newspaper publication)'
  //           },
  //           {
  //             value: 'Attestation letter from the principal of training school',
  //             label: 'Attestation letter from the principal of training school'
  //           },
  //           {
  //             value: 'Attestation letter from place of work',
  //             label: 'Attestation letter from place of work'
  //           },
  //           {
  //             value: 'Attestation letter from a responsible citizen',
  //             label: 'Attestation letter from a responsible citizen'
  //           }
  //         ]}
  //       />
  //     </div>
  //     <div className='col-lg-5'>
  //       {/* <span className='form-span'>Date commenced</span> */}
  //       {/* <input
  //         type='text'
  //         name={`eduCommenced${index}`}
  //         ref={register({ required: true })}
  //         {...form.getListInputProps('education', index, 'commenced')}
  //       /> */}

  //       <FilePond
  //         files={files}
  //         {...form.getListInputProps('documents', index, 'url')}
  //         maxFileSize='1MB'
  //         // acceptedFileTypes={[
  //         //   'image/jpeg, image/png',
  //         // ]}
  //         credits={false}
  //         onupdatefiles={(fileItems) => {
  //           setFiles(fileItems);
  //           fileItems.map((rawData) => {
  //             return Object.assign(rawData.file, {
  //               blob: URL.createObjectURL(rawData.file),
  //             });
  //           });
  //         }}
  //         // allowMultiple={true}
  //         maxFiles={1}
  //         instantUpload={false}
  //         name={`doc${index}`}
  //         labelIdle='Drag & Drop your documents or <span class="filepond--label-action">Browse</span>'
  //       />
  //     </div>
  //     <div className='col-lg-1'>
  //       <ActionIcon
  //         color='red'
  //         variant='hover'
  //         onClick={() => form.removeListItem('documents', index)}
  //       >
  //         <Trash size={16} />
  //       </ActionIcon>
  //     </div>
  //   </div>
  // ));

  // const docFields = form.values.documents.map((_, index) => (
  //   <div className='row rowStyle' key={index}>
  //     <div className='col-lg-6'>
  //       <span className='form-span'>Type of document</span>
  //       <NativeSelect
  //         name={`type${index}`}
  //         required
  //         {...form.getListInputProps('documents', index, 'name')}
  //         data={[
  //           {
  //             value: "Original O'Level Certificate",
  //             label: "Original O'Level Certificate",
  //           },
  //           {
  //             value: 'Original Practicing License',
  //             label: 'Original Practicing License',
  //           },
  //           {
  //             value: 'Original Certificate/Notification in General Nursing',
  //             label: 'Original Certificate/Notification in General Nursing',
  //           },
  //           {
  //             value: 'Birth Certificate/declaration of age',
  //             label: 'Birth Certificate/declaration of age',
  //           },
  //           {
  //             value:
  //               'School of Nursing Testimonial/Department of Nursing reference letter',
  //             label:
  //               'School of Nursing Testimonial/Department of Nursing reference letter',
  //           },
  //           {
  //             value:
  //               'Marriage certificate and change of name (newspaper publication)',
  //             label:
  //               'Marriage certificate and change of name (newspaper publication)',
  //           },
  //           {
  //             value: 'Attestation letter from the principal of training school',
  //             label: 'Attestation letter from the principal of training school',
  //           },
  //           {
  //             value: 'Attestation letter from place of work',
  //             label: 'Attestation letter from place of work',
  //           },
  //           {
  //             value: 'Attestation letter from a responsible citizen',
  //             label: 'Attestation letter from a responsible citizen',
  //           },
  //         ]}
  //       />
  //     </div>
  //     <div className='col-lg-5'>
  //       {/* <span className='form-span'>Date commenced</span> */}
  //       {/* <input
  //         type='text'
  //         name={`eduCommenced${index}`}
  //         ref={register({ required: true })}
  //         {...form.getListInputProps('education', index, 'commenced')}
  //       /> */}

  //       <FilePond
  //         // files={files}
  //         {...form.getListInputProps('documents', index, 'url')}
  //         maxFileSize='1MB'
  //         // acceptedFileTypes={[
  //         //   'image/jpeg, image/png',
  //         // ]}
  //         credits={false}
  //         onupdatefiles={(fileItems) => {
  //           const docName = form.values.documents[index].name;
  //           console.log('form', form.values.documents);
  //           setSFiles({
  //             ...sFiles,
  //             [docName]: [fileItems],
  //           });
  //           // fileItems.map((rawData) => {
  //           //   return Object.assign(rawData.file, {
  //           //     blob: URL.createObjectURL(rawData.file),
  //           //   });
  //           // });
  //         }}
  //         // allowMultiple={true}
  //         maxFiles={1}
  //         instantUpload={false}
  //         name={`doc${index}`}
  //         labelIdle='Drag & Drop your documents or <span class="filepond--label-action">Browse</span>'
  //       />
  //     </div>
  //     <div className='col-lg-1'>
  //       <ActionIcon
  //         color='red'
  //         variant='hover'
  //         onClick={() => form.removeListItem('documents', index)}
  //       >
  //         <Trash size={16} />
  //       </ActionIcon>
  //     </div>
  //   </div>
  // ));

  const defaultEducation = {
    name: '',
    commenced: '',
    left: '',
    subjects: '',
  };

  const defaultPro = {
    name: '',
    commenced: '',
    left: '',
    number: '',
  };

  const defaultEmployment = {
    name: '',
    date: '',
    post: '',
    reason: '',
  };

  const defaultDocument = {
    name: '',
    url: [],
  };

  return (
    <>
      <h2 className='blog-one__title'>Apply to the {local.course} program</h2>
      <form
        className='contact-one__form contact-form-validated contact-one'
        style={{ padding: 0 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className='row low-gutters'>
          <div className='col-lg-4'>
            <span className='form-span'>First Name</span>
            <input
              type='text'
              name='firstName'
              ref={register({ required: true })}
            />
            {errors.firstName && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Middle Name</span>
            <input type='text' name='middleName' ref={register()} />
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Surname</span>
            <input
              type='text'
              name='lastName'
              ref={register({ required: true })}
            />
            {errors.lastName && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Gender</span>
            <NativeSelect
              name='gender'
              ref={register({ required: true })}
              data={[
                {
                  value: 'Male',
                  label: 'Male',
                },
                {
                  value: 'Female',
                  label: 'Female',
                },
              ]}
            />
            {errors.gender && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Title</span>
            <NativeSelect
              name='title'
              ref={register({ required: true })}
              data={[
                {
                  value: 'Mr',
                  label: 'Mr',
                },
                {
                  value: 'Mrs',
                  label: 'Mrs',
                },
                {
                  value: 'Miss',
                  label: 'Miss',
                },
              ]}
            />
            {errors.title && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Date of Birth</span>
            <input type='date' name='dob' ref={register({ required: true })} />
            {errors.dob && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Email</span>
            <input
              type='email'
              name='email'
              ref={register({ required: true })}
            />
            {errors.email && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>{' '}
          <div className='col-lg-4'>
            <span className='form-span'>Phone Number</span>
            <input
              type='text'
              name='phone'
              ref={register({ required: true })}
            />
            {errors.phone && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>{' '}
          <div className='col-lg-4'>
            <span className='form-span'>RN License/Validity</span>
            <input
              type='text'
              name='validity'
              ref={register({ required: true })}
            />
            {errors.validity && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Marital Status</span>
            <NativeSelect
              name='maritalStatus'
              ref={register({ required: true })}
              data={[
                {
                  value: 'Married',
                  label: 'Married',
                },
                {
                  value: 'Single',
                  label: 'Single',
                },
                {
                  value: 'Widowed',
                  label: 'Widowed',
                },
              ]}
            />
            {errors.maritalStatus && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Maiden Name</span>
            <input type='text' name='maidenName' ref={register()} />
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Present Address</span>
            <textarea ref={register()} name='address'></textarea>
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Next of Kin</span>
            <input type='text' name='kin' ref={register({ required: true })} />
            {errors.kin && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Relationship to Next of Kin</span>
            <input
              type='text'
              name='relationship'
              ref={register({ required: true })}
            />
            {errors.relationship && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Phone Number of Next of Kin</span>
            <input
              type='text'
              name='nokPhone'
              ref={register({ required: true })}
            />
            {errors.nokPhone && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>
              Functional email address of Next of Kin
            </span>
            <input type='email' ref={register()} name='nokEmail'></input>
          </div>
          <div className='col-lg-7'>
            <span className='form-span'>
              House Address of Next of Kin (if different from above)
            </span>
            <textarea ref={register()} name='nokAddress'></textarea>
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Place of Birth</span>
            <input type='text' name='pob' ref={register({ required: true })} />
            {errors.pob && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Nationality</span>
            <input
              type='text'
              name='nationality'
              ref={register({ required: true })}
            />
            {errors.nationality && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>State of Origin</span>
            <input
              type='text'
              name='state'
              ref={register({ required: true })}
            />
            {errors.state && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Religion</span>
            <input
              type='text'
              name='religion'
              ref={register({ required: true })}
            />
            {errors.religion && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Is your father living?</span>
            <input type='text' name='livingFather' ref={register()} />
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>Is your mother living?</span>
            <input type='text' name='livingMother' ref={register()} />
          </div>
          <div className='col-lg-7'>
            <span className='form-span'>
              Name, occupation and business address of Father/Husband (if
              married)
            </span>
            <textarea ref={register()} name='fatherHusband'></textarea>
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>No of children, sexes and age</span>
            <textarea ref={register()} name='childrenDetails'></textarea>
          </div>
          <div className='col-lg-12'>
            <span className='form-span'>Educational background</span>
            {eduFields}
            <br />

            <button
              type='button'
              onClick={() => form.addListItem('education', defaultEducation)}
              className='thm-btn2'
            >
              Add New Education
            </button>
          </div>
          <div className='col-lg-12'>
            <span className='form-span'>
              Particulars of your professional training schools
            </span>
            {proFields}
            <br />
            <button
              type='button'
              onClick={() => form.addListItem('professional', defaultPro)}
              className='thm-btn2'
            >
              Add New Training Institution
            </button>
          </div>
          <div className='col-lg-12'>
            <span className='form-span'>
              Particulars of your employment since you left school and
              professional training
            </span>
            {empFields}
            <br />
            <button
              type='button'
              onClick={() => form.addListItem('employment', defaultEmployment)}
              className='thm-btn2'
            >
              Add New Employment
            </button>
          </div>
          <div className='col-lg-12'>
            <span className='form-span'>
              State names and address of 3 persons where whom reference may be
              obtained
            </span>
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>
              From your professional training school
            </span>
            <textarea
              type='text'
              name='proReference'
              ref={register({ required: true })}
            />
            {errors.proReference && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>
              From the Matron of your working place
            </span>
            <textarea
              type='text'
              name='matronReference'
              ref={register({ required: true })}
            />
            {errors.matronReference && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          <div className='col-lg-4'>
            <span className='form-span'>
              Responsible Senior Officer (not a relation)
            </span>
            <textarea
              type='text'
              name='officerReference'
              ref={register({ required: true })}
            />
            {errors.officerReference && (
              <span className='errorText'>
                <i className='fas fa-exclamation-triangle'></i> This field is
                required
              </span>
            )}
          </div>
          {/* <div className='col-lg-12'>
            <span className='form-span'>
              Upload all required documents
            </span>
            {docFields}
            <br />
            <button
              type='button'
              onClick={() => form.addListItem('documents', defaultDocument)}
              className='thm-btn2'
            >
              Upload new supporting document
            </button>
          </div> */}
          <div className='col-lg-3 offset-lg-5'>
            <span className='form-span'>Passport Photograph</span>
            <FilePond
              files={passport}
              maxFileSize='1MB'
              acceptedFileTypes={['image/*']}
              credits={false}
              onupdatefiles={(fileItems) => {
                console.log('fileitems', fileItems);
                setPassport(fileItems);
                fileItems.map((rawData) => {
                  return Object.assign(rawData.file, {
                    blob: URL.createObjectURL(rawData.file),
                  });
                });
              }}
              allowMultiple={false}
              instantUpload={false}
              name='passport'
              labelIdle='Drag & Drop your passport photograph or <span class="filepond--label-action">Browse</span>'
              imagePreviewHeight={170}
              imageCropAspectRatio='1:1'
              imageResizeTargetWidth={200}
              imageResizeTargetHeight={200}
              stylePanelLayout='compact circle'
              styleLoadIndicatorPosition='center bottom'
              styleProgressIndicatorPosition='right bottom'
              styleButtonRemoveItemPosition='left bottom'
              styleButtonProcessItemPosition='right bottom'
            />
          </div>
          <div className='col-lg-12'>
            <h4 className='form-span'>Upload Required Documents</h4>
            <h3 className='sidebar__title'>
              Note: All listed documents below must be uploaded for your
              admission to be considered
            </h3>
            <div className='row'>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Original Scan of School Certificate
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>Birth Certificate</p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Original Certificate/Notification in General Nursing
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Marriage certificate and change of name (newspaper
                  publication) (where applicable)
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Attestation letter from the principal of your training school
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Attestation letter from your place of work
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Attestation letter from a responsible citizen
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Testimonial from School of Nursing or reference letter from
                  Department of Nursing
                </p>
              </div>
              <div className='col-lg-4'>
                <p style={{ color: '#f16101' }}>
                  Original current practicing license as a registered nurse in
                  Nigeria, with 1 year post qualification experience
                </p>
              </div>
              <div className='col-lg-12'>
                <p style={{ color: '#f16101', fontWeight: 800 }}>
                  Passport Photograph must be coloured and on a white background
                  (corperate dressing)
                </p>
              </div>
            </div>
            <FilePond
              files={files}
              maxFileSize='1MB'
              // acceptedFileTypes={[
              //   'image/jpeg, image/png',
              // ]}
              credits={false}
              onupdatefiles={(fileItems) => {
                setFiles(fileItems);
                fileItems.map((rawData) => {
                  return Object.assign(rawData.file, {
                    blob: URL.createObjectURL(rawData.file),
                  });
                });
              }}
              allowMultiple={true}
              maxFiles={7}
              instantUpload={false}
              name='files'
              labelIdle='Drag & Drop your supporting documents or <span class="filepond--label-action">Browse</span>'
            />
          </div>
          <div className='col-lg-12'>
            {loading ? (
              <Loader size='xl' color='orange' variant='dots' />
            ) : (
              <button className='reply-form__btn thm-btn' type='submit'>
                Submit
              </button>
            )}
          </div>
          <Modal
            opened={errorModal}
            onClose={() => setErrorModal(false)}
            title='Error!'
          >
            An error occurred, while saving details, please try again
          </Modal>
          <Modal
            opened={opened}
            onClose={() => {
              // navigate('/');
              setOpened(false);
            }}
            title='Success'
          >
            <p className='about-two__text' style={{ textAlign: 'center' }}>
              Your application has been successfully submitted with Application
              Number <strong>{appNoSt}</strong>
              <br />
              <br />
              <button
                onClick={() => navigate('/')}
                type='button'
                className='contact-one__btn thm-btn'
              >
                Ok
              </button>
            </p>
          </Modal>
        </div>
      </form>
    </>
  );
};

export default Midwifery;
